<template>
  <div>
    <div v-motion-roll-visible-top class="absolute -left-20 -top-20">
      <img ref="hat" :src="birthdayHat"
        alt=""
        class="aspect-square w-36 -rotate-45"
      />
    </div>
    <div class="absolute bottom-0 right-0 w-full h-full flex items-center justify-center pointer-events-none">
      <div id="avatar"></div>
    </div>
    <audio v-show="false" controls autoplay>
      <source :src="birthdayTheme" type="audio/mpeg" />
    </audio>
    <template v-if="blowWhistle">
      <audio v-show="false" controls autoplay>
        <source :src="blowerSfx" type="audio/mpeg" />
      </audio>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useReward } from 'vue-rewards'

import birthdayTheme from '@/assets/audio/happy-birthday-to-you-bossa-nova.mp3'
import blowerSfx from '@/assets/audio/blower.mp3'
import birthdayHat from '@/assets/birthdayhat.png'

// Confetti
const { reward: confettiReward } = useReward('avatar', 'confetti', {
  zIndex: 2000,
  lifetime: 600,
  elementCount: 100,
  startVelocity: 38,
  spread: 60,
  angle: 130,
  elementSize: 10
})

const blowWhistle = ref(false)

onMounted(() => {
  setTimeout(() => {
    confettiReward()
    blowWhistle.value = true
  }, 1000)
})
</script>
